import React from 'react';
import { Section } from '../ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function Trampa() {
  return <Section background="dark" className="text-white" data-id="element-288">
      <div className="text-center mb-12" data-id="element-289">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-290">
          La trampa: creer que necesitás más información.
        </h2>
        <p className="text-xl text-stone-300 max-w-2xl mx-auto" data-id="element-291">
          Información hay de sobra. Lo que falta es esto:
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-292">
        {['Un menú simple', 'Una lista cerrada', 'Reemplazos cuando algo falla', 'Un plan de emergencia'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-stone-800 p-4 rounded-lg border border-stone-700" data-id="element-293">
            <CheckCircle2 className="w-5 h-5 text-emerald-400" data-id="element-294" />
            <span className="font-medium text-lg" data-id="element-295">{item}</span>
          </div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-296">
        <p className="text-2xl font-bold" data-id="element-297">
          O sea: <span className="text-amber-400" data-id="element-298">una semana resuelta.</span>
        </p>
      </div>
    </Section>;
}